import { AD_TRACK_REQUEST } from "./ActionConstant";

export const trackAd = (payload) => ({
  type: AD_TRACK_REQUEST,
  payload,
});
